/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteLoginRegisterCtrl',["$log","$scope", "$rootScope","Auth","WebPreLoaderData","CustomerView","CustomerSrv","CustomerData","Customer",
                "CookieFactory","MobileDeviceSrv", "OptInOutService", "Constants",
        function($log,$scope, $rootScope,Auth,WebPreLoaderData,CustomerView,CustomerSrv,CustomerData,Customer,CookieFactory,MobileDeviceSrv, OptInOutService, Constants)
        {

        //Categories.query($scope,false);
        $scope.dd =
            {
                view :
                {
                    displayError : false,
                    displayErrorLogin : false,
                    displayErrorMsg : false,
                    displayErrorPhoneNumber : false,
                    isSmsActivationCodeValidated : false,
                    isSmsActivationCodeSent : false,
                    smsActivationCode : null,
                    waitServerResponse : false,
                    errorMessage : null,
                    displayCantSendSms : false,
                    cookieError : false
                },
                smsActivationCodeSent : null,
                emailValidator: Constants.EMAIL
            }
        if ($scope.ad.view && !$scope.ad.view.customerView) {
            $scope.ad.view.customerView = new CustomerView();
            $scope.ad.view.customerView.domainView = $scope;
        }
        var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
        if (smsTries)
        {
            var now = new Date();
            var lastTry = new Date(smsTries.date);
            if ((now - lastTry.getTime())<1000*60*60*24) //less than one day
            {
                if (smsTries.nb>=3)//last try was less than one day and 3 tries
                    $scope.dd.view.displayCantSendSms = true;
            }
            else
            {
                smsTries.nb = 0;//more than one day : reset to 0
                CookieFactory.setCookie('flexyBeauty-smsTries',smsTries);
            }
        }
        else
        {
            CookieFactory.setCookie('flexyBeauty-smsTries',
                {nb : 0, date : new Date});//check that cookie can be saved
            smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
            if (!smsTries)
            {
                $scope.dd.view.displayCantSendSms = true;
                $scope.dd.view.cookieError = true;

            }
        }
        $scope.login  = function()
        {
            if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse)
                if ($scope.ad.view.customerView.canLoginOnWeb())
                {
                    $scope.dd.view.waitServerResponse = true;
                    var customer = new Customer();
                    if ($scope.ad.view.customerView.login && $scope.ad.view.customerView.login!='')
                        if ($scope.ad.view.customerView.login.indexOf("@")!=-1)//email
                            customer.email = $scope.ad.view.customerView.login;
                        else
                            customer.phone = $scope.ad.view.customerView.login;
                    customer.password =  $scope.ad.view.customerView.password;
                    Auth.loginToWebSite(WebPreLoaderData.companyCode,customer,
                        function () {
                        //Success login get Customer data from it
                            CustomerSrv.getData(customer,$scope.afterLoginSuccess,$scope.afterLoginError);
                        },$scope.afterLoginError);
                }
                else
                    $scope.dd.view.displayErrorLogin = true;
        };

        $scope.afterLoginSuccess = function(customer) {
            $scope.dd.view.waitServerResponse = false;
            if (customer !== null) {
                customer.password = null;//hide by security
                if ($scope.ad.nativeApp && $scope.ad.nativeApp.token) {
                    MobileDeviceSrv.setCustomer($scope.ad.nativeApp,customer.id);
                }
                $scope.ad.view.customerView.loadDataFrom(customer);
                $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
                $scope.ad.view.customerView.password = null;//hide by security
                $scope.ad.view.customerView.passwordAgain = null;//hide by security
                $scope.ad.customerConnected = true;
                $scope.openLocation("account");
            }

        };

        $scope.afterLoginError = function(errorCode,errorMessage)
        {
            $scope.dd.view.errorMessage = errorMessage;
            $scope.dd.view.waitServerResponse = false;

        };

        $scope.register = function() {
            let customerView = $scope.ad.view.customerView;
            if (!customerView || $scope.dd.view.waitServerResponse) {
                return;
            }

            if (!customerView.canRegisterOnWeb(true)) {
                $scope.dd.view.displayError = true;
                return;
            }

            $scope.dd.view.waitServerResponse = true;

            let customer = new Customer();
                customerView.copyDataTo(customer);

            CustomerSrv.register(customer, function(res) {
                customer.id = res.userId;

                if (customer.id && customerView && customerView.optInOutView) {
                    OptInOutService.create({
                        customerId: customer.id,
                        optInOut: customerView.optInOutView
                    }).then(function (data) {

                        Auth.changeUserFromWebSite(customer, res.companyCode, res.token);
                        $scope.afterLoginSuccess(customer);

                    }, function (error) {
                        if (error) {
                            if (error.data) {
                                $scope.afterLoginError(error.status, error.data.message);
                            }
                            if (error.consumerMessage) {
                                $scope.afterLoginError(error.status, error.consumerMessage);
                            }
                        }
                    });
                }
            }, function (error) {
                if (error && error.data) {
                    $scope.afterLoginError(error.status, error.data.message);
                }
            });
        };

        $scope.sendSmsActivationCode = function()
        {
            if (!$scope.ad.view.customerView || !$scope.ad.view.customerView.phone || $scope.dd.view.displayErrorPhoneNumber)
            {
                $scope.dd.view.displayErrorMsg = true;
                $scope.dd.view.displayError = true;
                return;
            }
            var customer = new Customer();
            $scope.ad.view.customerView.copyDataTo(customer);
            $scope.dd.view.waitServerResponse = true;
            $scope.dd.view.errorMessage = null;
            CustomerSrv.sendSmsActivationCode(
                customer,
                function (smsActivationCodeSent) {  //success sent
                    $scope.dd.smsActivationCodeSent = smsActivationCodeSent;
                    $scope.dd.view.isSmsActivationCodeSent = true;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.displayErrorMsg = false;
                    if (smsTries)
                    {
                        smsTries.nb++;
                        smsTries.date = new Date();
                        CookieFactory.setCookie('flexyBeauty-smsTries',smsTries);
                        if (smsTries.nb>=3)
                            $scope.dd.view.displayCantSendSms = true;
                    }
                },
                function (errorCode,errorMessage) {
                    $scope.dd.view.isSmsActivationCodeSent = false;
                    $scope.dd.view.waitServerResponse = false;//TODO MANAGE ERROR
                    $scope.dd.view.displayError = true;
                    $scope.dd.view.displayErrorMsg = true;
                    $scope.dd.view.errorMessage = errorMessage;
                }
            );
            $scope.dd.view.displayError = false;
        };
        $scope.validateSmsActivationCode = function()
        {
            if($scope.dd.smsActivationCodeSent == $scope.dd.view.smsActivationCode)
            {
                $scope.dd.view.isSmsActivationCodeValidated = true;
                $scope.dd.view.displayError = false;
                $scope.ad.view.customerView.isVerified = true;
            }
            else
                $scope.dd.view.displayError = true;

        };
    }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteLoginRegisterCtrl.js